module.exports = __webpack_public_path__ + "static/commerce2x-access-control-level-863c2eeb5c583c7c7f852e04bcfc33a8.png";